import api from './api';
import { Inventory, InventoryCategory, InventoryGroup, CreateInventoryRequest } from '../types/inventory';

// Category Management
export async function createCategory(name: string) {
    return api.post<{ data: InventoryCategory; success: boolean; message: string }>('/inventory/categories', { name });
}

export async function updateCategory(id: number, name: string) {
    return api.put<{ data: InventoryCategory; success: boolean; message: string }>(`/inventory/categories/${id}`, { name });
}

export async function deleteCategory(id: number) {
    return api.delete<{ success: boolean; message: string }>(`/inventory/categories/${id}`);
}

// Group Management
export async function createGroup(categoryId: number, name: string) {
    return api.post<{ data: InventoryGroup; success: boolean; message: string }>('/inventory/groups', {
        inventory_category_id: categoryId,
        name
    });
}

export async function updateGroup(id: number, categoryId: number, name: string) {
    return api.put<{ data: InventoryGroup; success: boolean; message: string }>(`/inventory/groups/${id}`, {
        inventory_category_id: categoryId,
        name
    });
}

export async function deleteGroup(id: number) {
    return api.delete<{ success: boolean; message: string }>(`/inventory/groups/${id}`);
}

// Existing functions
export async function getInventories(search?: string, per_page?: number, page?: number) {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (per_page) params.append('per_page', per_page.toString());
    if (page) params.append('page', page.toString());

    return api.get<{
        success: boolean;
        data: {
            current_page: number;
            data: Inventory[];
            first_page_url: string;
            from: number;
            last_page: number;
            last_page_url: string;
            links: Array<{ url: string | null; label: string; active: boolean }>;
            next_page_url: string | null;
            path: string;
            per_page: number;
            prev_page_url: string | null;
            to: number;
            total: number;
        }
    }>(`/inventories?${params.toString()}`);
}

export async function getInventory(id: number) {
    return api.get<{ data: Inventory; success: boolean }>(`/inventories/${id}`);
}

export async function createInventory(data: CreateInventoryRequest) {
    return api.post<{ data: Inventory; success: boolean; message: string }>('/inventories', data);
}

export async function updateInventory(id: number, data: Partial<CreateInventoryRequest>) {
    return api.put<{ data: Inventory; success: boolean; message: string }>(`/inventories/${id}`, data);
}

export async function deleteInventory(id: number) {
    return api.delete<{ success: boolean; message: string }>(`/inventories/${id}`);
}

export async function getCategories() {
    return api.get<{ data: InventoryCategory[]; success: boolean }>('/inventory/categories');
}

export async function getGroups(categoryId?: number) {
    const params = new URLSearchParams();
    if (categoryId) params.append('category_id', categoryId.toString());

    return api.get<{ data: InventoryGroup[]; success: boolean }>(`/inventory/groups?${params.toString()}`);
} 